import { Text } from "@chakra-ui/react";
import StockCurrentScore from "../../../components/StockCurrentScore";

export function StockScoreCurrentScreen() {
    return (
        <>
        <StockCurrentScore/>
        </>
    )
 }